const searchFilters = {
  SEARCH_BY: "searchBy",
  BRAND: "brand",
  MODEL: "model",
  MODEL_TYPE: "modelType",
  PUBLICATION_TYPE: "publicationType",
  LANGUAGE: "language",
  PART_NUMBER: "partNumber",
  LINE_OFF_DATE: "lineOffDate",
  METADATA: "metadata",
  SEARCH_BY_PUBLICATION: "PUBLICATION",
};

export default searchFilters;
